import React from 'react';
import { wrapFunctionalComponent } from 'utils/framework';
import {
    fontSizes, fontWeights, mediaQueries, space
} from 'style/config';
import localeUtils from 'utils/LanguageLocale';
import BundleWidgetEN from 'components/ProductPage/PdpBundling/BundleWidget/locales/BundleWidget_en_US';
import BundleWidgetFR from 'components/ProductPage/PdpBundling/BundleWidget/locales/BundleWidget_fr_CA';

const getText = localeUtils.getLocalisedDataFromResource(BundleWidgetEN, BundleWidgetFR);

const parsePrice = priceStr => parseFloat((priceStr || '0').replace(/[^0-9.]/g, '')) || 0;

const PriceTotal = ({ currentProduct, bundleProducts }) => {
    const allSkus = [currentProduct, ...(bundleProducts || [])];
    const total = allSkus.reduce((sum, sku) => {
        const price = sku?.salePrice || sku?.listPrice;

        return sum + parsePrice(price);
    }, 0);

    return (
        <div css={styles.container}>
            <span css={styles.text}>{getText('estimatedPrice')}</span>
            <span css={styles.text}>${total.toFixed(2)}</span>
        </div>
    );
};

const styles = {
    container: {
        display: 'flex',
        justifyContent: 'space-between',
        width: '100%',
        [mediaQueries.sm]: {
            justifyContent: 'flex-start',
            gap: space[1]
        }
    },
    text: {
        fontSize: fontSizes.md,
        fontWeight: fontWeights.bold
    }
};

export default wrapFunctionalComponent(PriceTotal, 'PriceTotal');
